import { create } from "zustand"

type AddClinicMemberModalStore = {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

const useAddClinicMemberModalStore = create<AddClinicMemberModalStore>(
  (set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  })
)

export default useAddClinicMemberModalStore
